import {
  Box,
  Button,
  Stack,
  Typography
} from '@mui/material';
import { LoginForm } from 'modules/components/layer12';
import { ForgotPasswordModal } from 'modules/components/layer17';
import React, { useState } from 'react';



export type LoginDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: LoginDetailSectionProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  return (
    <Box
      minWidth='20rem'
      margin='auto'
    >
      {isVisible && (
        <ForgotPasswordModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <Box>
        <Stack
          rowGap='1rem'
          paddingBottom='4rem'
        >
          <Typography
            variant='activityHeader'
          >
            Welcome
          </Typography>
          <Typography
            variant='activitySubHeaderPrimary'
          >
            Type in your data below to start managing your project.
          </Typography>
        </Stack>
        <LoginForm.FC />
        <Button
          onClick={() => setIsVisible(() => true)}
          fullWidth
          variant='text'
        >
          Forgot password
        </Button>
      </Box>
    </Box>
  );
};
